<template>
  <span class="charge-text-block">
    <div :class="{bj:direction=='left',bj1:direction=='right'}"></div>
    <div class="content">
      <span class="c-row" :class="{'c-number':direction=='left','c-number1':direction=='right'}">{{data.number}}</span>
      <span class="c-row" :class="{'c-title':direction=='left','c-title1':direction=='right'}">{{data.title}}</span>
    </div>
  </span>
</template>

<script>
  export default{
    props:{
      data:{
        type:Object
      },
      direction:{
        type:String,
        default:'left'
      }
    },
    data(){
      return {
        title:''
      }
    },
    methods:{
    },
    mounted() {
    }
  }
</script>

<style lang="scss">
  .charge-text-block{
   position: relative;
   top: 0;
   left: 0;
   width: 112px;
   height: 61px;
   display: inline-block;
   .bj{
     position: absolute;
     top: 0px;
     left: 0px;
     z-index: 1;
     width: 112px;
     height: 61px;
     background: linear-gradient(270deg, rgba(3, 64, 127, 0) 0%, #004C9C 100%);
   }
   .bj1{
     position: absolute;
     top: 0px;
     left: 0px;
     z-index: 1;
     width: 112px;
     height: 61px;
     background: linear-gradient(90deg, rgba(3, 64, 127, 0) 0%, #004C9C 100%);
   }
   .content{
     position: absolute;
     top: 0px;
     left: 0px;
     z-index: 10;
     color: #FFFFFF;
     width: 100%;
     .c-row{
      display: inline-block;
      margin-left: 15px;
     }
     .c-number{
       height: 32px;
       font-size: 24px;
       // font-family: DINBold, DINAlternate;
       font-weight: bold;
       color: #00DDE0;
       width: 100%;
       top:8px;
       position: absolute;
     }
     .c-title{
       width: 100px;
       font-size: 12px;
       font-family: MicrosoftYaHei;
       color: #FFFFFF;
       position: absolute;
       top: 28px;
       display: inline-block;
     }
     .c-number1{
       height: 32px;
       font-size: 24px;
       // font-family: DINBold, DINAlternate;
       font-weight: bold;
       color: #FFAB58;
       width: 100%;
       top:8px;
       right: 15px;
       text-align: right;
       position: absolute;
     }
     .c-title1{
       width: 100px;
       font-size: 12px;
       font-family: MicrosoftYaHei;
       color: #FFFFFF;
       position: absolute;
       top: 28px;
       right: 15px;
       text-align: right;
       display: inline-block;
     }
   }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/charge-text-block.vue